<template>
  <l-cache :get-data="getGroupType" :id="$route.query.id" ref="cache">
    <l-layout slot-scope="{data}" :layout="[ 'xs12']">
      <v-card>
        <v-card-title style="height: 64px">
          <span class="title pl-2">{{data.name}}</span>
          <v-layout class="pl-4" wrap>
            <v-flex xs6>
              <span class="grey--text caption mr-2">创建时间</span>
              <span class="pr-4">{{$L.time.stringify(data.creationTime) || 'N/A'}}</span>
            </v-flex>
            <v-flex xs6>
              <span class="grey--text caption mr-2">上次更新</span>
              <span class="pr-4">{{$L.time.stringify(data.lastUpdateTime) || 'N/A'}}</span>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <v-btn @click="goEdit(data)" color="primary" flat small>编辑</v-btn>
          <v-btn @click="$refs.cache.retry()" color="primary" flat small>刷新</v-btn>
        </v-card-title>
        <v-card-text>
          <v-container class="py-0" fluid grid-list-md>
            <v-layout class="mb-4" wrap>
              <v-flex xs12>
                <v-text-field
                  disabled
                  label="类型名称"
                  placeholder="N/A"
                  prepend-icon="$vuetify.icons.group"
                  v-model="data.name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  :rows="1"
                  auto-grow
                  disabled
                  label="类型描述"
                  placeholder="N/A"
                  prepend-icon="$vuetify.icons.description"
                  v-model="data.description"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </l-layout>
  </l-cache>
</template>

<script>

export default {
  name: 'GroupTypeDetails',
  data: () => ({}),
  methods: {
    async getGroupType () {
      let {items} = await this.$store.dispatch('userAdmin/getGroupTypes', {
        pagination: {},
        filter: [{key: 'id', value: this.$route.query.id}],
      })
      if (items && items.length > 0) {
        let p = items[0]
        return p
      }
      else {
        throw Error('未找到该分组类型')
      }
    },
    async goEdit (type) {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'EditGroupType',
          params: {name: type.name},
          query: {id: type.id}
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
